import React, { useEffect, useRef, useState } from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import store from '../../../store/store';
import { _h5_link_to } from '../../../store/Action';
import RiskCheckboxContent from './RiskCheckboxContent';
import RiskCaptchaContent from './RiskCaptchaContent';
import RiskRealnameContent from './RiskRealnameContent';
import IframMiniModal from '../../iframModal/IframMiniModal';
import './index.scss';

const RiskManage = ({ base }) => {
  const { riskAuthData } = base;
  const [isRiskCheckbox, setIsRiskCheckbox] = useState(false); // 是否展示选项内容
  const [isRiskCaptcha, setIsRiskCaptcha] = useState(false); // 是否展示极验
  const [isRiskRealname, setIsRiskRealname] = useState(false); // 是否展示实名内容
  const iframeElement = useRef(null);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    return () => {
      window.removeEventListener('message', iframeElementCallback);
    };
  }, []);

  useEffect(() => {
    if (riskAuthData?.isTrigger) {
      //组合验证
      if (riskAuthData?.multiple) {
        setIsRiskCheckbox(true);
      } else {
        //单个极验
        if (riskAuthData?.singleType == 0) {
          setIsRiskCaptcha(false);
          setTimeout(() => {
            setIsRiskCaptcha(true);
          }, 50);
        } else if (riskAuthData?.singleType == 1 && riskAuthData?.cert) {
          setIsRiskRealname(true);
        } else if (riskAuthData?.singleType == -1) {
          setIsRiskCheckbox(true);
        }
      }
    }
  }, [riskAuthData]);

  // 风控选项框完成
  const checkboxSuccess = () => {
    if (riskAuthData?.contentValid?.subType === 1) {
      const url = `/question-risk-check?sceneType=${riskAuthData.sceneType}`;
      _h5_link_to(url).then((res) => {
        iframeElement.current.showModal(
          res.url + '?' + qs.stringify(res.params),
          { zIndex: 1009 }
        );
      });
      window.addEventListener('message', iframeElementCallback);
    } else if (riskAuthData?.geeTest?.enable) {
      setIsRiskCaptcha(false);
      setTimeout(() => {
        setIsRiskCaptcha(true);
      }, 50);
    } else if (riskAuthData?.cert) {
      setIsRiskRealname(true);
    } else {
      clearRiskData();
    }
    setIsRiskCheckbox(false);
  };

  const iframeElementCallback = (msg) => {
    if (msg?.data?.key === 'riskQuestionSuccess') {
      iframeElement.current.hideModal();
      riskAuthData.contentValid.subType = 2;
      questionSuccess();
    } else if (msg?.data?.key === 'riskQuestionFail') {
      iframeElement.current.hideModal();
      clearRiskData();
    }
  };

  // 风控答题完成
  const questionSuccess = () => {
    if (riskAuthData?.geeTest?.enable) {
      setIsRiskCaptcha(true);
    } else if (riskAuthData?.cert) {
      setIsRiskRealname(true);
    } else {
      clearRiskData();
    }
  };

  // 风控极验认证完成
  const captchaSuccess = () => {
    setIsRiskCaptcha(false);
    if (riskAuthData.cert) {
      setIsRiskRealname(true);
    } else {
      clearRiskData();
    }
  };
  // 风控极验认证取消
  const captchaCancel = () => {
    setIsRiskCaptcha(false);
    clearRiskData();
  };

  // 实名认证完成
  const realnameSuccess = () => {
    setIsRiskRealname(false);
    clearRiskData();
  };
  // 实名认证取消
  const realnameCancel = () => {
    setIsRiskRealname(false);
    clearRiskData();
  };
  // 风控选项框内容取消
  const checkboxCancel = () => {
    setIsRiskCheckbox(false);
    clearRiskData();
  };

  const clearRiskData = () => {
    store.dispatch({ type: 'risk_auth_data', data: { riskAuthData: null } });
  };

  return (
    <>
      <div className="risk-manage-page">
        {/* 风控选项框内容 */}
        <RiskCheckboxContent
          visible={isRiskCheckbox}
          onCancel={checkboxCancel}
          onSuccess={checkboxSuccess}
        />
        {/* 风控极验内容 */}
        <RiskCaptchaContent
          visible={isRiskCaptcha}
          onCancel={captchaCancel}
          onSuccess={captchaSuccess}
        />
        {/* 风控实名内容 */}
        <RiskRealnameContent
          visible={isRiskRealname}
          onCancel={realnameCancel}
          onSuccess={realnameSuccess}
        />

        {/* H5弹窗 */}
        <IframMiniModal
          wrappedComponentRef={iframeElement}
          isShowClose={false}
        />
      </div>
    </>
  );
};

export default connect((store) => ({ base: store }))(RiskManage);
